import {filter, curry} from 'ramda'

// liftArray :: x|[x] -> [x]
// Ensures that the provided value is an array. If it isn't, it will be converted
// to an array with one value.
export const liftArray = x => Array.isArray(x) ? x : [x]

// excludeEmpty :: Filterable -> Filterable
// Gets rid of anything empty (empty string, undefined, null)
export const excludeEmpty = filter(x => x !== '' && x !== 0 && x !== undefined && x !== null)

// Filters an object or an array. Provides (value, key) to the callback function.
export const filterKV = curry((f, xs) => {
    return Array.isArray(xs)
        ? xs.filter((v, k) => f(v, k))
        : Object.keys(xs).reduce((acc, k) => {
            const v = xs[k]

            if(f(v, k)) {
                acc[k] = v
            }

            return acc
        }, {})
})

// reduce an object or an array. Provides (acc, value, key) to the callback function.
export const reduceKV = curry((f, initialValue, xs) => {
    return Array.isArray(xs)
        ? xs.reduce((acc, v, k) => f(acc, v, k), initialValue)
        : Object.keys(xs).reduce((acc, k) => {
            const v = xs[k]
            return f(acc, v, k)
        }, initialValue)
})

export const report = curry((msg, x) => { console.log(msg, x); return x })

export function debounce(wait, f) {
    let timeoutId = null;

    return (...args) => {
        clearTimeout(timeoutId);

        timeoutId = setTimeout(() => {
            f.apply(null, args);
        }, wait);

    };

}



// WEBPACK FOOTER //
// ./react/utils/f.js